import React, { useContext } from 'react';
import classNames from 'classnames';

import { css } from '@emotion/css';
import { EMPTY_ELEMENT } from 'common/utils/react';

import { DrainContext, DrainType } from 'contexts/DrainContext';
import { FilterInput } from 'components/library/FilterInput';
import { FilterTaxonomy, getFilterTaxonomyOptions } from 'api/queries/filter';
import { map, sum } from 'lodash';

const classes = {
  filter: {
    element: (hasFilter: boolean, hasSorting: boolean) => css`
      position: relative;
      width: ${hasFilter && hasSorting ? '50%' : '100%'};
      margin-right: 12px;
      &:last-child {
        margin-right: 0;
      }
    `,
    marker: {
      root: css`
        position: absolute;
        top: -4px;
        right: 3px;
        background-color: #276ef1;
        height: 12px;
        width: 12px;
        border-radius: 50%;
        margin-top: 4px;
      `,
      item: css`
        font-size: 14px;
        padding-left: 5px;
        padding-top: 0;
        color: #ffffff;
        font-weight: 600;
        line-height: 100%;
      `,
    },
  },
};

type Props = {
  className: string;
  filterList?: FilterTaxonomy;
};

const FilterGroupMobile = ({ className, filterList }: Props) => {
  const drain = useContext(DrainContext);

  const hasFilter = sum(map(filterList.elements, ({ terms }) => terms.length)) > 0;
  const hasSorting = getFilterTaxonomyOptions(filterList).sort.switched;

  return (
    <div className={className}>
      <div className={classNames([classes.filter.element(hasFilter, hasSorting)])}>
        <FilterInput filterList={filterList} className="flex-1 relative" type={DrainType.Filter} />
        {drain.filter.elements.length > 0 ? <div className={classes.filter.marker.root} /> : EMPTY_ELEMENT}
      </div>
      {hasSorting ? (
        <div className={classes.filter.element(hasFilter, hasSorting)}>
          <FilterInput filterList={filterList} className="flex-1 relative" type={DrainType.Sorting} />
        </div>
      ) : (
        EMPTY_ELEMENT
      )}
    </div>
  );
};

export default FilterGroupMobile;
